<template>
	<div>
		<transition
			name="fade"
			enter-active-class="animated fadeIn"
			leave-active-class="animated fadeOut"
		>
			<b-container>
				<h3
					v-if="isSurety && routeName == 'firstSuretyResidentialInfo'"
					class="text-center  mb-5 textBlue"
				>
					{{ $t("register.firstSuretyResidentialInfo") }}
				</h3>
				<h3
					v-if="isSurety && routeName == 'secondSuretyResidentialInfo'"
					class="text-center  mb-5 textBlue"
				>
					{{ $t("register.secondSuretyResidentialInfo") }}
				</h3>

				<h3 v-if="!isSurety" class="text-center  mb-5 textBlue">
					{{ $t("register.residentialInfo") }}
				</h3>

				<b-form @submit.stop.prevent="onSubmit">
					<!-- ++++++++++++++++ ADDRESS SECTION ++++++++++++++++++++ -->
					<section>
						<!-- ================================= province $ city  ============================== -->
						<b-row align-h="between">
							<!--------------------------------- province -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="province_group"
									:label="$t('register.province')"
									label-cols-sm="4"
									label-for="province"
								>
									<b-form-input
										id="province"
										type="text"
										v-model="$v.form.province.$model"
										:state="validateState('province')"
										aria-describedby="province-live-feedback"
									></b-form-input>
									<b-form-invalid-feedback id="province-live-feedback">
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
							<!--------------------------------- city -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="city_group"
									:label="$t('register.city')"
									label-for="city"
									label-cols-sm="4"
								>
									<b-form-input
										id="city"
										v-model="$v.form.city.$model"
										:state="validateState('city')"
										aria-describedby="city-live-feedback"
									></b-form-input>
									<b-form-invalid-feedback id="city-live-feedback">
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
						</b-row>

						<!-- ================================= Address & postal Code ============================== -->
						<b-row align-h="between">
							<!--------------------------------- address -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="caddress_group"
									:label="$t('register.address')"
									label-for="address"
									label-cols-sm="4"
								>
									<b-form-textarea
										id="address"
										type="textbox"
										v-model="$v.form.address.$model"
										:state="validateState('address')"
										aria-describedby="address-live-feedback"
										rows="1"
										max-rows="3"
										size="sm"
									></b-form-textarea>
								</b-form-group>
							</b-col>
							<!--------------------------------- postal_code -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="postal_code_group"
									:label="$t('register.postalCode')"
									label-cols-sm="4"
									label-for="postal_code"
								>
									<b-form-input
										id="postal_code"
										type="number"
										v-model="$v.form.postal_code.$model"
										:state="validateState('postal_code')"
										aria-describedby="postal_code-live-feedback"
									></b-form-input>
									<b-form-invalid-feedback
										id="postal_code-live-feedback"
										v-show="!$v.form.postal_code.required"
									>
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
									<b-form-invalid-feedback
										id="postal_code-live-feedback"
										v-show="
											!$v.form.postal_code.minLength |
												!$v.form.postal_code.maxLength
										"
									>
										{{ $t("validation.postalCodeInvalid") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
						</b-row>
					</section>
					<!-- ++++++++++++++++ ESTATE SECTION ++++++++++++++++++++ -->
					<section class="ESTATE">
						<!-- ================================= Estate Status ============================== -->
						<b-row align-h="between">
							<!--------------------------------- home_type -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="home_types_group"
									:label="$t('register.estateState')"
									label-for="home_type"
									label-cols-sm="3"
									:state="validateState('home_type')"
									v-slot="{ home_type_des }"
								>
									<b-form-radio-group
										v-model="$v.form.home_type.$model"
										:options="home_type_options"
										:aria-describedby="home_type_des"
										class="pt-1"
									>
										<b-form-invalid-feedback
											id="home_type-live-feedback"
											:state="validateState('home_type')"
										>
											{{ $t("validation.requiredToFill") }}
										</b-form-invalid-feedback>
									</b-form-radio-group>
								</b-form-group>
							</b-col>
							<b-col md="3"></b-col>
						</b-row>
						<!-- ========================================+++++++ personal ++++++++=============================== -->
						<section id="personal">
							<transition
								name="fadeIn"
								enter-active-class="animated fadeIn"
								leave-active-class="animated fadeOut"
							>
								<div v-if="form.home_type == '0'">
									<b-row align-h="between">
										<!--------------------------------- document_type -----------------------------------------  -->
										<b-col md="6">
											<b-form-group
												id="document_type_group"
												:label="$t('register.typeOfDocument')"
												label-cols-sm="4"
												label-for="document_type"
												:state="validateStateOwner('document_type')"
											>
												<b-form-select
													v-model="$v.form.personalhome.document_type.$model"
													:options="document_type_options"
													:state="validateStateOwner('document_type')"
													aria-describedby="document_type-live-feedback"
													class="form-control"
												></b-form-select>
												<b-form-invalid-feedback
													id="document_type-live-feedback"
												>
													{{ $t("validation.requiredToFill") }}
												</b-form-invalid-feedback>
											</b-form-group>
										</b-col>

										<!--------------------------------- is_owner -----------------------------------------  -->
										<b-col md="6">
											<b-form-radio-group
												v-model="$v.form.personalhome.is_owner.$model"
												:options="is_owner_options"
												aria-describedby="is_owner-live-feedback"
												class="pt-1"
											>
												<b-form-invalid-feedback
													id="is_owner-live-feedback"
													:state="validateStateOwner('is_owner')"
												>
													{{ $t("validation.requiredToFill") }}
												</b-form-invalid-feedback>
											</b-form-radio-group>
										</b-col>
									</b-row>
									<!--========================== document unique Number ====================================== -->
									<section>
										<transition
											name="fadeIn"
											enter-active-class="animated fadeIn"
											leave-active-class="animated fadeOut"
										>
											<b-row
												align-h="between"
												v-show="form.personalhome.document_type == '0'"
											>
												<!----------------- unique number --------------- -->
												<b-col md="6">
													<b-form-group
														id="unique_number_group"
														:label="$t('register.uniqueNumber')"
														label-cols-sm="4"
														label-for="unique_number"
														:state="validateStateOwner('unique_number')"
													>
														<b-form-input
															v-model="
																$v.form.personalhome.unique_number.$model
															"
															:state="validateStateOwner('unique_number')"
															aria-describedby="unique_number-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="unique_number-live-feedback"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>

												<b-col md="6"> </b-col>
											</b-row>
										</transition>
									</section>

									<!--========================== real_state_number & page_number ====================================== -->
									<section>
										<transition
											name="fadeIn"
											enter-active-class="animated fadeIn"
											leave-active-class="animated fadeOut"
										>
											<b-row
												align-h="between"
												v-show="form.personalhome.document_type == '1'"
											>
												<!----------------- real_state_number --------------- -->
												<b-col md="6">
													<b-form-group
														id="real_state_number_group"
														:label="$t('register.realStateNumber')"
														label-cols-sm="4"
														label-for="real_state_number"
														:state="validateStateOwner('real_state_number')"
													>
														<b-form-input
															v-model="
																$v.form.personalhome.real_state_number.$model
															"
															:state="validateStateOwner('real_state_number')"
															aria-describedby="real_state_number-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="real_state_number-live-feedback"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>

												<!----------------- page_number --------------- -->
												<b-col md="6">
													<b-form-group
														id="page_number_group"
														:label="$t('register.pageNumber')"
														label-cols-sm="4"
														label-for="page_number"
														:state="validateStateOwner('page_number')"
													>
														<b-form-input
															v-model="$v.form.personalhome.page_number.$model"
															type="number"
															:state="validateStateOwner('page_number')"
															aria-describedby="page_number-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="page_number-live-feedback"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
											</b-row>
										</transition>
									</section>

									<!-- ++++++ owner section +++++ -->
									<transition
										name="fadeIn"
										enter-active-class="animated fadeIn"
										leave-active-class="animated fadeOut"
									>
										<!-- ++++++ owner section +++++ -->
										<section
											v-show="
												(form.home_type == '0') &
													(form.personalhome.is_owner == '0')
											"
										>
											<b-row align-h="between">
												<!--------------------------------- owner relationship  -----------------------------------------  -->
												<b-col md="6">
													<b-form-group
														id="owner_relationship_group"
														:label="$t('register.relation')"
														label-cols-sm="4"
														label-for="owner_relationship"
														:state="validateStateOwner('relationship')"
														:description="$t('register.ownerRelationDes')"
													>
														<b-form-input
															id="owner_relationship"
															type="text"
															v-model="$v.form.personalhome.relationship.$model"
															:state="validateStateOwner('relationship')"
															aria-describedby="owner_relationship-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="owner_relationship-live-feedback"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
												<b-col md="6"></b-col>
											</b-row>

											<!-- ================================= name $ lastName ============================== -->
											<b-row align-h="between">
												<!--------------------------------- Name -----------------------------------------  -->
												<b-col md="6">
													<b-form-group
														id="owner_name_group"
														:label="$t('register.name')"
														label-cols-sm="4"
														label-for="owner_name"
													>
														<b-form-input
															id="owner_name"
															type="text"
															v-model="$v.form.personalhome.first_name.$model"
															:state="validateStateOwner('first_name')"
															aria-describedby="owner_name-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="owner_name-live-feedback"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
												<!--------------------------------- LastName -----------------------------------------  -->
												<b-col md="6">
													<b-form-group
														id="owner_last_name_group"
														:label="$t('register.lastName')"
														label-for="owner_lastName"
														label-cols-sm="4"
													>
														<b-form-input
															id="owner_last_name"
															v-model="$v.form.personalhome.last_name.$model"
															:state="validateStateOwner('last_name')"
															aria-describedby="owner_last_name-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="owner_last_name-live-feedback"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
											</b-row>

											<!-- ================================= mobileNumber $ melliCode ============================== -->
											<b-row align-h="between">
												<!--------------------------------- mobileNumber -----------------------------------------  -->
												<b-col md="6">
													<b-form-group
														id="owner_mobile_number_group"
														type="tel"
														:label="$t('register.mobileNumber')"
														label-cols-sm="4"
														label-for="owner_mobile_number"
													>
														<b-form-input
															id="owner_mobile_number"
															type="number"
															v-model="
																$v.form.personalhome.mobile_number.$model
															"
															:state="validateStateOwner('mobile_number')"
															aria-describedby="owner_mobile_number-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="owner_mobile_number-live-feedback"
															v-show="
																!$v.form.personalhome.mobile_number.required
															"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
														<b-form-invalid-feedback
															id="owner_mobile_number-live-feedback"
															v-show="
																!$v.form.personalhome.mobile_number.minLength |
																	!$v.form.personalhome.mobile_number.maxLength
															"
														>
															{{ $t("validation.mobileInvalid") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
												<!--------------------------------- melliCode -----------------------------------------  -->
												<b-col md="6">
													<b-form-group
														id="owner_melli_code_group"
														:label="$t('register.melliCode')"
														label-for="owner_melli_code"
														label-cols-sm="4"
													>
														<b-form-input
															id="owner_melli_code"
															type="number"
															v-model="$v.form.personalhome.melli_code.$model"
															aria-describedby="owner_melli_code-live-feedback"
															:state="validateStateOwner('melli_code')"
														></b-form-input>
														<b-form-invalid-feedback
															id="owner_melli_code-live-feedback"
															v-show="!$v.form.personalhome.melli_code.required"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
														<b-form-invalid-feedback
															id="owner_melli_code-live-feedback"
															v-show="
																!$v.form.personalhome.melli_code.checkMelliCode
															"
														>
															{{ $t("validation.MelliCodeCheck") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
											</b-row>
										</section>
									</transition>
								</div>
							</transition>
						</section>
						<!-- ========================================+++++++ rental ++++++++=============================== -->
						<section id="rental">
							<transition
								name="fadeIn"
								enter-active-class="animated fadeIn"
								leave-active-class="animated fadeOut"
							>
								<section v-if="form.home_type == '2'">
									<b-row align-h="center" class="mb-5">
										<!--------------------------------- renter -----------------------------------------  -->
										<b-col md="7">
											<b-form-radio-group
												v-model="$v.form.rentalhome.is_mine.$model"
												:options="rentalhome_options"
												aria-describedby="renter-live-feedback"
												class="pt-1"
											>
												<b-form-invalid-feedback
													id="renter-live-feedback"
													:state="validStateRental('is_mine')"
												>
													{{ $t("validation.requiredToFill") }}
												</b-form-invalid-feedback>
											</b-form-radio-group>
										</b-col>
									</b-row>

									<transition
										name="fadeIn"
										enter-active-class="animated fadeIn"
										leave-active-class="animated fadeOut"
									>
										<!-- ++++++ renter section +++++ -->
										<div
											v-show="
												(form.home_type == '2') &
													(form.rentalhome.is_mine == '1')
											"
										>
											<b-row align-h="between">
												<!--------------------------------- renter relationship  -----------------------------------------  -->
												<b-col md="6">
													<b-form-group
														id="renter_relationship_group"
														:label="$t('register.relation')"
														label-cols-sm="4"
														label-for="renter_relationship"
														:description="$t('register.renterRelationDes')"
													>
														<b-form-input
															id="renter_relationship"
															type="text"
															v-model="$v.form.rentalhome.relationship.$model"
															:state="validStateRental('relationship')"
															aria-describedby="renter_relationship-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="renter_relationship-live-feedback"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
												<b-col md="6"></b-col>
											</b-row>

											<!-- ================================= name $ lastName ============================== -->
											<b-row align-h="between">
												<!--------------------------------- Name -----------------------------------------  -->
												<b-col md="6">
													<b-form-group
														id="renter_name_group"
														:label="$t('register.name')"
														label-cols-sm="4"
														label-for="renter_name"
													>
														<b-form-input
															id="renter_name"
															type="text"
															v-model="$v.form.rentalhome.first_name.$model"
															:state="validStateRental('first_name')"
															aria-describedby="renter_name-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="renter_name-live-feedback"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
												<!--------------------------------- LastName -----------------------------------------  -->
												<b-col md="6">
													<b-form-group
														id="renter_last_name_group"
														:label="$t('register.lastName')"
														label-for="renter_lastName"
														label-cols-sm="4"
													>
														<b-form-input
															id="renter_last_name"
															v-model="$v.form.rentalhome.last_name.$model"
															:state="validStateRental('last_name')"
															aria-describedby="renter_last_name-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="renter_last_name-live-feedback"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
											</b-row>

											<!-- ================================= mobileNumber $ melliCode ============================== -->
											<b-row align-h="between">
												<!--------------------------------- mobileNumber -----------------------------------------  -->
												<b-col md="6">
													<b-form-group
														id="renter_mobile_number_group"
														type="tel"
														:label="$t('register.mobileNumber')"
														label-cols-sm="4"
														label-for="renter_mobile_number"
													>
														<b-form-input
															id="renter_mobile_number"
															type="number"
															v-model="$v.form.rentalhome.mobile_number.$model"
															:state="validStateRental('mobile_number')"
															aria-describedby="renter_mobile_number-live-feedback"
														></b-form-input>
														<b-form-invalid-feedback
															id="renter_mobile_number-live-feedback"
															v-show="
																!$v.form.rentalhome.mobile_number.required
															"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
														<b-form-invalid-feedback
															id="renter_mobile_number-live-feedback"
															v-show="
																!$v.form.rentalhome.mobile_number.minLength |
																	!$v.form.rentalhome.mobile_number.maxLength
															"
														>
															{{ $t("validation.mobileInvalid") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
												<!--------------------------------- melliCode -----------------------------------------  -->
												<b-col md="6">
													<b-form-group
														id="renter_melli_code_group"
														:label="$t('register.melliCode')"
														label-for="renter_melli_code"
														label-cols-sm="4"
													>
														<b-form-input
															id="renter_melli_code"
															type="number"
															v-model="$v.form.rentalhome.melli_code.$model"
															aria-describedby="renter_melli_code-live-feedback"
															:state="validStateRental('melli_code')"
														></b-form-input>
														<b-form-invalid-feedback
															id="renter_melli_code-live-feedback"
															v-show="!$v.form.rentalhome.melli_code.required"
														>
															{{ $t("validation.required") }}
														</b-form-invalid-feedback>
														<b-form-invalid-feedback
															id="renter_melli_code-live-feedback"
															v-show="
																!$v.form.rentalhome.melli_code.checkMelliCode
															"
														>
															{{ $t("validation.MelliCodeCheck") }}
														</b-form-invalid-feedback>
													</b-form-group>
												</b-col>
											</b-row>
										</div>
									</transition>
								</section>
							</transition>
							<!-- +++++++ rent amount and due date  -->
							<transition
								name="fadeIn"
								enter-active-class="animated fadeIn"
								leave-active-class="animated fadeOut"
							>
								<section v-if="form.home_type == '2'">
									<!-- --------------------------rental_rate ------------------------ -->
									<b-row align-h="between">
										<b-col md="6">
											<b-form-group
												id="rental_rate_group"
												:label="$t('register.rental_rate')"
												label-for="rental_rate"
												label-cols-sm="4"
											>
												<b-form-input
													id="rental_rate"
													type="number"
													v-model="$v.form.rentalhome.rental_rate.$model"
													:state="validStateRental('rental_rate')"
													aria-describedby="rental_rate-live-feedback"
												></b-form-input>
												<b-form-invalid-feedback
													id="rental_rate-live-feedback"
													v-show="!$v.form.rentalhome.rental_rate.required"
												>
													{{ $t("validation.required") }}
												</b-form-invalid-feedback>
												<b-form-invalid-feedback
													id="rental_rate-live-feedback"
													v-show="!$v.form.rentalhome.rental_rate.minLength"
												>
													{{ $t("validation.amountInvalid") }}
												</b-form-invalid-feedback>
											</b-form-group>
										</b-col>
										<!--------------------------------- due date -----------------------------------------  -->
										<b-col md="6">
											<b-form-group
												id="rent_due_date_group"
												:label="$t('register.rent_due_date')"
												label-for="rent_due_date"
												label-cols-sm="4"
											>
												<date-picker
													id="rent_due_date"
													v-model="form.rentalhome.due_date"
													placeholder="1399/8/23"
													format="YYYY-MM-DD"
													display-format="jYYYY/jMM/jDD"
													:min="minDate"
													:max="maxDate"
													initial-value="1981/03/21"
													view="year"
													color="#5c6bc0"
													simple
												>
													<div slot="label"></div>
												</date-picker>
												<b-form-invalid-feedback
													id="rent_due_date-live-feedback"
												>
													{{ $t("validation.required") }}
												</b-form-invalid-feedback>
											</b-form-group>
										</b-col>
									</b-row>

									<!-- --------------------------tracking_code ------------------------ -->
									<b-row align-h="between">
										<b-col md="6">
											<b-form-group
												id="tracking_code_group"
												:label="$t('register.trackingCode')"
												label-for="tracking_code"
												label-cols-sm="4"
												:description="$t('register.trackingCodeDes')"
											>
												<b-form-input
													id="tracking_code"
													type="text"
													v-model="$v.form.rentalhome.tracking_code.$model"
													:state="validStateRental('tracking_code')"
													aria-describedby="tracking_code-live-feedback"
												></b-form-input>
												<b-form-invalid-feedback
													id="tracking_code-live-feedback"
												>
													{{ $t("validation.required") }}
												</b-form-invalid-feedback>
											</b-form-group>
										</b-col>

										<b-col md="6"> </b-col>
									</b-row>
								</section>
							</transition>
						</section>
						<!-- end of rental section -->

						<!-- ========================================+++++++ organization ++++++++=============================== -->
						<section id="organization">
							<transition
								name="fadeIn"
								enter-active-class="animated fadeIn"
								leave-active-class="animated fadeOut"
							>
								<section v-if="form.home_type == '1'">
									<b-row align-h="center" class="mb-5">
										<b-col md="6">
											<b-form-group
												id="organization_title_group"
												:label="$t('register.organizationName')"
												label-cols-sm="2"
												label-for="organization_title"
											>
												<b-form-input
													id="organization_title"
													type="text"
													v-model="$v.form.organizationhome.title.$model"
													:state="validStateOrgan('title')"
													aria-describedby="organization_title-live-feedback"
												></b-form-input>
												<b-form-invalid-feedback
													id="organization_title-live-feedback"
												>
													{{ $t("validation.required") }}
												</b-form-invalid-feedback>
											</b-form-group>
										</b-col>
										<b-col md="6"></b-col>
									</b-row></section
							></transition>
						</section>
					</section>

					<b-row align-h="center" v-show="!edit">
						<b-button
							type="submit"
							size="lg"
							class="btn btn-bg--primary  btn-size--md btn-hover--3d mt-5 mb-3"
							center
							>{{ $t("register.save") }}</b-button
						>
					</b-row>
					<b-row align-h="center" v-show="edit">
						<b-button
							type="button"
							size="lg"
							class="btn btn-bg--primary  btn-size--md btn-hover--3d mt-5 mb-3"
							center
							@click.prevent="updateCustomer"
							>{{ $t("register.edit") }}</b-button
						>
					</b-row>
				</b-form>
			</b-container>
		</transition>
	</div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import { validationMixin } from "vuelidate";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {
	required,
	minLength,
	maxLength,
	requiredIf,
} from "vuelidate/lib/validators";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
export default {
	mixins: [validationMixin],
	data() {
		return {
			isSurety: false,
			isRegisterCompleted: false,
			edit: "",
			form: {
				province: "",
				city: "",
				address: "",
				postal_code: "",
				melli_code: "",
				mobile_number: "",
				home_type: "2",
				personalhome: {
					is_personal: false,
					relationship: "",
					first_name: "",
					last_name: "",
					mobile_number: "",
					melli_code: "",
					document_type: "",
					is_owner: "",
					unique_number: "",
					real_state_number: "",
					page_number: "",
				},
				organizationhome: {
					is_organization: false,
					title: "",
				},

				rentalhome: {
					is_rental: true,
					relationship: "",
					first_name: "",
					last_name: "",
					mobile_number: "",
					melli_code: "",
					rental_rate: "",
					is_mine: "",
					due_date: "",
					tracking_code: "",
				},
			},
			home_type_options: [
				{ value: "2", text: this.$t("register.estate.rental") },
				{ value: "0", text: this.$t("register.estate.personal") },

				{ value: "1", text: this.$t("register.estate.Organizational") },
			],
			document_type_options: [
				{ value: "1", text: this.$t("register.houseDocument.tasselDocument") },
				{
					value: "0",
					text: this.$t("register.houseDocument.singleSheetDocument"),
				},
			],
			is_owner_options: [
				{ value: "1", text: this.$t("register.estate.owner") },
				{ value: "0", text: this.$t("register.estate.notOwner") },
			],
			rentalhome_options: [
				{ value: "0", text: this.$t("register.estate.isRenter") },
				{ value: "1", text: this.$t("register.estate.notRenter") },
			],
		};
	},
	computed: {
		getHomeType() {
			return this.form.home_type;
		},
		maxDate() {
			var today = new Date();
			var month = 1 + today.getMonth();
			var max_date =
				5 + today.getFullYear() + "-" + month + "-" + today.getDate();
			return max_date;
		},
		minDate() {
			var today = new Date();
			var month = ((3 + today.getMonth()) % 12) + 1;
			var year = today.getFullYear();
			if (3 + today.getMonth() >= 12) {
				year = year + 1;
			}
			var min_date = year + "-" + month + "-" + today.getDate();
			return min_date;
		},
	},
	watch: {
		routeName: {
			handler: function() {
				this.checkRouteName();
			},
		},
		getHomeType: function(type) {
			console.log("==========", type);
			if (type == "0") {
				this.form.personalhome.is_personal = true;
				this.form.rentalhome.is_rental = false;
				this.form.organizationhome.is_organization = false;
			} else if (type == "1") {
				this.form.personalhome.is_personal = false;
				this.form.rentalhome.is_rental = false;
				this.form.organizationhome.is_organization = true;
			} else if (type == "2") {
				this.form.personalhome.is_personal = false;
				this.form.rentalhome.is_rental = true;
				this.form.organizationhome.is_organization = false;
			}
		},
	},
	validations: {
		form: {
			province: { required },
			city: { required },
			address: { required },
			postal_code: {
				required,
				minLength: minLength(10),
				maxLength: maxLength(10),
			},
			home_type: { required },

			personalhome: {
				relationship: {
					required: requiredIf((rental) => {
						if (rental.is_personal & (rental.is_owner == "0")) return true;
						return false;
					}),
				},
				first_name: {
					required: requiredIf((rental) => {
						if (rental.is_personal & (rental.is_owner == "0")) return true;
						return false;
					}),
				},
				last_name: {
					required: requiredIf((rental) => {
						if (rental.is_personal & (rental.is_owner == "0")) return true;
						return false;
					}),
				},
				mobile_number: {
					required: requiredIf((rental) => {
						if (rental.is_personal & (rental.is_owner == "0")) return true;
						return false;
					}),
					minLength: minLength(11),
					maxLength: maxLength(11),
				},
				melli_code: {
					required: requiredIf((rental) => {
						if (rental.is_personal & (rental.is_owner == "0")) return true;
						return false;
					}),
					checkMelliCode(code) {
						if (code == "") {
							return true;
						} else {
							if (
								!/^\d{10}$/.test(code) ||
								code == "0000000000" ||
								code == "1111111111" ||
								code == "2222222222" ||
								code == "3333333333" ||
								code == "4444444444" ||
								code == "5555555555" ||
								code == "6666666666" ||
								code == "7777777777" ||
								code == "8888888888" ||
								code == "9999999999"
							)
								return false;
							var check = parseInt(code[9]);
							var sum = 0;
							var i;
							for (i = 0; i < 9; ++i) {
								sum += parseInt(code[i]) * (10 - i);
							}
							sum %= 11;
							return (
								(sum < 2 && check == sum) || (sum >= 2 && check + sum == 11)
							);
						}
					},
				},
				document_type: {
					required: requiredIf((rental) => {
						if (rental.is_personal) return true;
						return false;
					}),
				},
				is_owner: {
					required: requiredIf((rental) => {
						if (rental.is_personal) return true;
						return false;
					}),
				},
				unique_number: {
					required: requiredIf((rental) => {
						if (rental.is_personal & (rental.document_type == "0")) return true;
						return false;
					}),
				},
				real_state_number: {
					required: requiredIf((rental) => {
						if (rental.is_personal & (rental.document_type == "1")) return true;
						return false;
					}),
				},
				page_number: {
					required: requiredIf((rental) => {
						if (rental.is_personal & (rental.document_type == "1")) return true;
						return false;
					}),
				},
			},

			organizationhome: {
				title: {
					required: requiredIf((rental) => {
						console.log("is organ:", rental);
						if (rental.is_organization) return true;
						return false;
					}),
				},
			},
			rentalhome: {
				relationship: {
					required: requiredIf((rental) => {
						if (rental.is_rental & (rental.is_mine == "1")) return true;
						return false;
					}),
				},
				first_name: {
					required: requiredIf((rental) => {
						if (rental.is_rental & (rental.is_mine == "1")) return true;
						return false;
					}),
				},
				last_name: {
					required: requiredIf((rental) => {
						if (rental.is_rental & (rental.is_mine == "1")) return true;
						return false;
					}),
				},
				mobile_number: {
					required: requiredIf((rental) => {
						if (rental.is_rental & (rental.is_mine == "1")) return true;
						return false;
					}),
					minLength: minLength(11),
					maxLength: maxLength(11),
				},
				melli_code: {
					required: requiredIf((rental) => {
						if (rental.is_rental & (rental.is_mine == "1")) return true;
						return false;
					}),
					checkMelliCode(code) {
						if (code == "") {
							return true;
						} else {
							if (
								!/^\d{10}$/.test(code) ||
								code == "0000000000" ||
								code == "1111111111" ||
								code == "2222222222" ||
								code == "3333333333" ||
								code == "4444444444" ||
								code == "5555555555" ||
								code == "6666666666" ||
								code == "7777777777" ||
								code == "8888888888" ||
								code == "9999999999"
							)
								return false;
							var check = parseInt(code[9]);
							var sum = 0;
							var i;
							for (i = 0; i < 9; ++i) {
								sum += parseInt(code[i]) * (10 - i);
							}
							sum %= 11;
							return (
								(sum < 2 && check == sum) || (sum >= 2 && check + sum == 11)
							);
						}
					},
				},
				rental_rate: {
					required: requiredIf((rental) => {
						if (rental.is_rental) return true;
						return false;
					}),
					maxLength: maxLength(2),
				},
				is_mine: {
					required: requiredIf((rental) => {
						if (rental.is_rental) return true;
						return false;
					}),
				},
				// due_date: {
				// 	required: requiredIf((rental) => {
				// 		if (rental.is_rental) return true;
				// 		return false;
				// 	}),
				// },
				tracking_code: {
					required: requiredIf((rental) => {
						if (rental.is_rental) return true;
						return false;
					}),
				},
			},

			// ============================================
		},
	},
	mounted() {
		console.log(this.minDate);
		// console.log(moment(toString(this.min_date,'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'));
		this.checkRouteName();
	},

	props: ["routeName"],

	methods: {
		checkRouteName() {
			if (
				this.routeName == "firstSuretyResidentialInfo" ||
				this.routeName == "SuppliersCustomerEditFirstSuretyResidentialInfo"
			) {
				this.isRegisterCompleted = true;
				this.isSurety = true;
				this.getFirstSurety();
			} else if (
				this.routeName == "secondSuretyResidentialInfo" ||
				this.routeName == "SuppliersCustomerEditSecondSuretyResidentialInfo"
			) {
				this.isRegisterCompleted = true;
				this.isSurety = true;
				this.getSecondSurety();
			} else if (
				this.routeName == "editResidentialInfo" ||
				this.routeName == "SupplierEditCustomerResidentialInfo"
			) {
				this.isRegisterCompleted = true;
				this.isSurety = false;
				this.getCustomer();
			} else {
				this.isRegisterCompleted = false;
				this.getCustomer();
			}
		},
		onSubmit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				console.log(this.$v.form);

				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				let form = "";
				form = JSON.parse(JSON.stringify(this.form));
				if (this.form.home_type == "0") {
					form.rentalhome = null;
					form.organizationhome = null;
					if (this.form.personalhome.is_owner == "1") {
						form.personalhome.first_name = "";
						form.personalhome.last_name = "";
						form.personalhome.melli_code = "";
						form.personalhome.mobile_number = "";
						form.personalhome.relationship = "0";
					}
					if (this.form.personalhome.document_type == "0") {
						form.personalhome.page_number = 0;
						form.personalhome.real_state_number = "";
					}
					if (this.form.personalhome.document_type == "1") {
						form.personalhome.unique_number = "";
					}
				} else if (this.form.home_type == "1") {
					form.rentalhome = null;
					form.personalhome = null;
				} else if (this.form.home_type == "2") {
					form.personalhome = null;
					form.organizationhome = null;
					if (this.form.rentalhome.is_mine == "0") {
						form.rentalhome.first_name = "";
						form.rentalhome.last_name = "";
						form.rentalhome.melli_code = "";
						form.rentalhome.mobile_number = "";
						form.rentalhome.relationship = "0";
					}
				}
				console.log(form);
				this.$store
					.dispatch("updateCustomer", form)
					.then((response) => {
						console.log(response);
						load.hide();
						if (!this.editResidentialInfo) {
							this.$router.push({ name: "registerPage" });
						}
					})
					.catch((err) => {
						console.log(err);
						this.$noty.error(err.body.Error);
						load.hide();
					});
			}
		},
		getCustomer() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getCustomer")
				.then((response) => {
					console.log(response);
					load.hide();
					this.form = response.body;
					this.checkResponse(response);
				})
				.catch((err) => {
					console.log(err);
					this.$noty.error(err.body.Error);
					load.hide();
					this.edit = false;
				});
		},
		updateCustomer() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				console.log(this.$v.form);

				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				let form = {
					province: this.form.province,
					city: this.form.city,
					address: this.form.address,
					postal_code: this.form.postal_code,
					home_type: this.form.home_type,
					personalhome: {
						relationship: this.form.personalhome.relationship,
						first_name: this.form.personalhome.first_name,
						last_name: this.form.personalhome.last_name,
						mobile_number: this.form.personalhome.mobile_number,
						melli_code: this.form.personalhome.melli_code,
						document_type: this.form.personalhome.document_type,
						is_owner: this.form.personalhome.is_owner,
						unique_number: this.form.personalhome.unique_number,
						real_state_number: this.form.personalhome.real_state_number,
						page_number: this.form.personalhome.page_number,
					},
					organizationhome: {
						title: this.form.organizationhome.title,
					},
					rentalhome: {
						is_rental: this.form.rentalhome.is_rental,
						relationship: this.form.rentalhome.relationship,
						first_name: this.form.rentalhome.first_name,
						last_name: this.form.rentalhome.last_name,
						mobile_number: this.form.rentalhome.mobile_number,
						melli_code: this.form.rentalhome.melli_code,
						rental_rate: this.form.rentalhome.rental_rate,
						is_mine: this.form.rentalhome.is_mine,
						due_date: this.form.rentalhome.due_date,
						tracking_code: this.form.rentalhome.tracking_code,
					},
				};

				if (this.form.home_type == "0") {
					form.rentalhome = null;
					form.organizationhome = null;
					if (this.form.personalhome.is_owner == "1") {
						form.personalhome.first_name = "";
						form.personalhome.last_name = "";
						form.personalhome.melli_code = "";
						form.personalhome.mobile_number = "";
						form.personalhome.relationship = "0";
					}
					if (this.form.personalhome.document_type == "0") {
						form.personalhome.page_number = 0;
						form.personalhome.real_state_number = "";
					}
					if (this.form.personalhome.document_type == "1") {
						form.personalhome.unique_number = "";
					}
				} else if (this.form.home_type == "1") {
					form.rentalhome = null;
					form.personalhome = null;
				} else if (this.form.home_type == "2") {
					form.personalhome = null;
					form.organizationhome = null;
					if (this.form.rentalhome.is_mine == "0") {
						form.rentalhome.first_name = "";
						form.rentalhome.last_name = "";
						form.rentalhome.melli_code = "";
						form.rentalhome.mobile_number = "";
						form.rentalhome.relationship = "0";
					}
				}
				console.log(form);
				if (!this.isSurety) {
					this.$store
						.dispatch("updateCustomer", form)
						.then((response) => {
							console.log(response);
							load.hide();
							this.$noty.success(this.$t("alert.successUpdated"));
							if (!this.isRegisterCompleted) {
								// eslint-disable-line no-mixed-spaces-and-tabs
								this.$router.push({ name: "registerPage" });
							}
						})
						.catch((err) => {
							console.log(err);
							this.$noty.error(err.body.Error);
							load.hide();
						});
				} else {
					form.melli_code = this.form.melli_code;
					form.mobile_number = this.form.mobile_number;
					this.$store
						.dispatch("updateSurety", form)
						.then((response) => {
							console.log(response);
							load.hide();
							this.$noty.success(this.$t("alert.successUpdated"));
							//this.$router.push({ name: "registerPage" });
						})
						.catch((err) => {
							console.log(err);
							this.$noty.error(err.body.Error);
							load.hide();
						});
				}
			}
		},
		changeOwner(e) {
			console.log("event: " + e + this.form.personalhome.is_owner);
		},
		getFirstSurety() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getFirstSurety")
				.then((response) => {
					if (JSON.stringify(response.body) != "{}") {
						this.form.mobile_number = response.body.mobile_number;
						this.form.melli_code = response.body.melli_code;
						console.log(response);
						load.hide();
						this.form = response.body;
						this.edit = true;
						// this.isSuretyRegistered=true

						this.checkResponse(response);
					} else {
						//this.$router.push("/customer/firstSuretyIdentityInfo")
						if (!localStorage.getItem("SupplierCustomerId")) {
							this.$router.push("/customer/firstSuretyIdentityInfo");
						} else {
							this.$router.push({
								name: "SuppliersCustomerEditFirstSuretyIdentityInfo",
							});
						}

						load.hide();
					}
				})
				.catch((err) => {
					if (err.status == 404) {
						//this.$router.push("/customer/firstSuretyIdentityInfo")
						if (!localStorage.getItem("SupplierCustomerId")) {
							this.$router.push("/customer/firstSuretyIdentityInfo");
						} else {
							this.$router.push({
								name: "SuppliersCustomerEditFirstSuretyIdentityInfo",
							});
						}
					}
					if (err.status != 404) {
						this.$noty.error(err.body.Error);
					}
					load.hide();
					this.edit = false;
				});
		},
		getSecondSurety() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getSecondSurety")
				.then((response) => {
					if (JSON.stringify(response.body) != "{}") {
						this.form.mobile_number = response.body.mobile_number;
						this.form.melli_code = response.body.melli_code;
						console.log(response);
						load.hide();
						this.form = response.body;
						this.edit = true;
						// this.isSuretyRegistered=true

						this.checkResponse(response);
					} else {
						//this.$router.push("/customer/secondSuretyIdentityInfo")

						if (!localStorage.getItem("SupplierCustomerId")) {
							this.$router.push("/customer/secondSuretyIdentityInfo");
						} else {
							this.$router.push({
								name: "SuppliersCustomerEditSecondSuretyIdentityInfo",
							});
						}
						load.hide();
					}
				})
				.catch((err) => {
					if (err.status == 404) {
						if (!localStorage.getItem("SupplierCustomerId")) {
							this.$router.push("/customer/secondSuretyIdentityInfo");
						} else {
							this.$router.push({
								name: "SuppliersCustomerEditSecondSuretyIdentityInfo",
							});
						}
					}
					if (err.status != 404) {
						this.$noty.error(err.body.error);
					}

					load.hide();
					this.edit = false;
				});
		},
		checkResponse(response) {
			if (response.body.rentalhome == null) {
				this.form.rentalhome = {
					is_rental: false,
					relationship: "",
					first_name: "",
					last_name: "",
					mobile_number: "",
					melli_code: "",
					rental_rate: "",
					is_mine: "",
					due_date: "",
					tracking_code: "",
				};
			}
			if (response.body.organizationhome == null) {
				this.form.organizationhome = {
					title: "",
					is_organization: false,
				};
			}
			if (response.body.personalhome == null) {
				this.form.personalhome = {
					is_personal: false,
					relationship: "",
					first_name: "",
					last_name: "",
					mobile_number: "",
					melli_code: "",
					document_type: "",
					is_owner: "",
					unique_number: "",
					real_state_number: "",
					page_number: "",
				};
			}
			console.log("form:  == ", this.form);
			this.edit = true;
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.form[name];
			return $dirty ? !$error : null;
		},

		validateStateOwner(name) {
			const { $dirty, $error } = this.$v.form.personalhome[name];
			return $dirty ? !$error : null;
		},
		validStateRental(name) {
			const { $dirty, $error } = this.$v.form.rentalhome[name];
			return $dirty ? !$error : null;
		},
		validStateOrgan(name) {
			const { $dirty, $error } = this.$v.form.organizationhome[name];
			return $dirty ? !$error : null;
		},
	},
	components: {
		datePicker: VuePersianDatetimePicker,
	},
};
</script>

<style scoped scr="bootstrap/dist/css/bootstrap.css"></style>
<style scoped scr="bootstrap-vue/dist/bootstrap-vue.csss"></style>
